package ar.corzo.health_tracker

import kotlinx.browser.document
import react.create
import react.dom.client.createRoot
import web.dom.Element

fun main() {
    val container = document.getElementById("root") ?: error("Couldn't find container!")

    createRoot(container = container as Element).render(App.create())
}